<header aria-label="Main header" class="box__shadow" role="banner">
  <div class="container container--header">
    <!-- TODO: Translate -->
    <a [routerLink]="[baseUrl]" aria-label="Back to start page" class="logo__holder">
      <img alt="{{'images_alt.logo' | translate}}" class="logo desktop-only" src="{{assetPath}}/logo_desktop.svg"/>
      <img alt="{{'images_alt.logo' | translate}}" class="logo mobile-only" src="{{assetPath}}/logo_mobile.svg"/>
    </a>

    @if (!isContentPage && isAuthenticated) {
      <nav aria-label="main navigation">
        <ul>
          <li>
            @if ((userLevel ?? 0) > 1) {
              <!--continue game-->
              <a (click)="navigateToGame()" [routerLink]="[baseUrl, Route.GAME]" aria-label="Start game"
                 class="nav-link"
                 routerLinkActive="active">{{ 'navigation.game' | translate }}</a>
            } @else {
              <a (click)="startGame()" [routerLink]="[baseUrl, Route.GAME]" aria-label="Start game" class="nav-link"
                 routerLinkActive="active">{{ 'navigation.game' | translate }}</a>
            }
          </li>
          <li>
            <a
                    (click)="openInNewTab(Route.FAQS)"
                    aria-label="Frequently asked questions"
                    class="nav-link"
                    style="cursor: pointer"
            >FAQs</a
            >
          </li>
          @if (hasLearnings) {
            <li>
              <a
                      (click)="openInNewTab(Route.DATA_AND_AI_LEARNINGS)"
                      aria-label="Data & AI Learnings at MyGenius und KI Lernen"
                      class="nav-link"
                      style="cursor: pointer"
              >Data & AI Learnings</a
              >
            </li>
          }
        </ul>
      </nav>
      <div aria-label="meta navigation" class="meta-nav">
        <gandalf-countdown></gandalf-countdown>
        <div class="user-info">
          @if (isDevelopment || hasRestart) {
            <span class="mr-1">
              <eon-ui-icon
                      (click)="confirmRestart()"
                      name="reload"
                      scheme="{{eonUiHeaderScheme}}"
                      title="{{'header.restart_game' | translate}}">
              </eon-ui-icon>
            </span>
          }
          @if (isAuthenticated) {
            <eon-ui-icon (click)="logout()" name="logout" scheme="white" title="Logout"></eon-ui-icon>
          }
        </div>
      </div>
      @if (availableLanguages.length > 1) {
        <div class="i18n_switcher">
          @for (lang of availableLanguages; track lang; let last = $last) {
            <button (click)="switchLang(lang)" [class.active]="currentLang() === lang" role="button">
              {{ lang.toUpperCase() }}
            </button>
            @if (!last) {
              <span></span>
            }
          }
        </div>
      }
    }
    @if (isContentPage) {
      <nav aria-label="content navigation" class="nav__content">
        <eon-ui-button
                (click)="closeTab()"
                aria-label="{{'buttons.close_tab' | translate}}"
                rank="secondary"
                scheme="{{eonUiHeaderScheme}}"
                size="small"
                text="{{'buttons.close_tab' | translate}}"
        >
        </eon-ui-button
        >
      </nav>
    }
  </div>

  <!-- Mobile nav -->
  <button (click)="showMobileNav = !showMobileNav" aria-expanded="{{ showMobileNav }}" aria-label="Menü öffnen"
          class="burger">
    <eon-ui-icon name="menu" scheme="white"></eon-ui-icon>
  </button>

  <div [ngClass]="{ hidden: !showMobileNav, visible: showMobileNav }" class="mobile-nav-overlay">
    <button (click)="showMobileNav = !showMobileNav" aria-label="Menü schließen" class="close">
      <eon-ui-icon name="close" scheme="white"></eon-ui-icon>
    </button>
    <nav aria-label="mobile navigation" class="mobile-nav">
      <ul>
        <li><a (click)="showMobileNav = false" [routerLink]="[Route.BASE]">Start</a></li>
        <li><a (click)="showMobileNav = false" [routerLink]="[Route.GAME]">Game</a></li>
        <li><a (click)="openInNewTab(Route.FAQS); showMobileNav = false">FAQs</a></li>
        @if (hasLearnings) {
          <li><a (click)="openInNewTab(Route.DATA_AND_AI_LEARNINGS); showMobileNav = false">Data & AI Learnings</a></li>
        }
      </ul>
    </nav>
  </div>
</header>
